import * as angular from 'angular';

export const planningProjectDraftMapSection = {
  template: require('./planning-project-draft-map-section.html').default || require('./planning-project-draft-map-section.html'),
  bindings: {
    visibleMinimizedPanels: '<',
    minimizedPanels: '<',
    visibleMinimizedPanelsCount: '<',
    invisibleMinimizedPanels: '<',
    jobs: '<',
    routes: '<',
    resources: '<',
    siteFiltersType: '<',
    isMorePanelsDropdownOpen: '<',
    getRouteColor: '&',
    getRouteServicesCount: '&',
    panelHasFilters: '&',
    selectedOverviewType: '<',
    project: '<',
    draft: '<',
    isDuplicateDraftDisabled: '<',
    viewConfiguration: '<',
    highlightedActivity: '<',
    highlightedActivityRoute: '<',
    highlightedActivityJobs: '<',
    depots: '<',
    leftoverStops: '<',
    hiddenRouteIds: '<',
    mapLayers: '<',
    selectedJobIds: '<',
    serviceAreas: '<',
    clusteringAreas: '<',
    zoomActivityId: '<',
    highlightedLeftoverIds: '<',
    highlightedRouteIds: '<',
    isTimelineFullScreen: '<',
    analysis: '<',
    leftoverJobs: '<',
    selectedLeftoverIds: '<',
    selectedRouteId: '<',
    canEdit: '<',
    timelineEnabled: '<',
    isGroupedRoutes: '<',
    getJobsByIds: '<',
    isLoading: '<',

    onMaximizePanel: '&',
    onClosePanel: '&',
    onToggleMorePanelsDropdown: '&',
    onCloseHiddenMinimizedPanels: '&',
    onToggleDraftOverview: '&',
    onViewConfigurationChange: '&',
    onEditDraftSettings: '&',
    onOptimizeDraft: '&',
    onDuplicateDraft: '&',
    onDeleteDraft: '&',
    onMoveToLeftovers: '&',
    onViewJob: '&',
    onActivityHighlight: '&',
    onMoveActivity: '&',
    onRoutedJobSelect: '&',
    onLeftOverJobSelect: '&',
    onLeftOverMultipleJobSelect: '&',
    onActivitySelection: '&',
    onAddStopsToRoute: '&',
    onHiddenRouteIdsChange: '&',
    onMapLayersChange: '&',
    onSelectRoute: '&',
    onClusterToggle: '&',
    setAllLeftOverSelection: '&',
    onToggleRouteDisplay: '&',
    onViewRoute: '&',
    onRecalcRoute: '&',
    onDeleteRoutes: '&',
    onDispatchRoutes: '&',
    onLockRouteChange: '&',
    onZoomActivity: '&',
    onRemoveActivityFromRoute: '&',
    onToggleGroupedRoutes: '&',
    onExportDraftSvg: '&',
    onApproveAndDispatchDraft: '&',
    onChangeRouteResource: '&',
    onTimelineFullScreen: '&',
    onToggleTimeline: '&'
  }
};

angular
  .module('bringoz.admin.planning')
  .component('planningProjectDraftMapSection', planningProjectDraftMapSection);
